<template>
    <modal
        name="project-modal"
        :adaptive="true"
        :height="'auto'"
        @before-open="onModalShow"
    >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Nome missione</label>
                                    <input type="text" name="project_name" readonly v-model="newProjectName" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="currentUser.type === 1">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Utente</label>
                                    <select class="custom-select" v-model="project.project_company">
                                        <option :value="null" disabled>-- Seleziona un utente --</option>
                                        <option v-for="user in computedUsers" :key="user.id" :value="user.value">
                                            {{ user.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-for="(p, i) in projectRoutes" :key="i">
                            <div class="col-12">
                                <label>Tratta #{{ i + 1 }}</label>
                            </div>
                            <div class="col-5">
                                <div class="form-group">
                                    <v-select
                                        v-model="projectRoutes[i].route"
                                        :options="routes"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="form-group">
                                    <date-picker input-class="form-control" v-model="projectRoutes[i].date"></date-picker>
                                    <!-- <datepicker  format="dd/MM/yyyy"></datepicker> -->
                                    <!-- <input class="form-control" type="date" v-model="projectRoutes[i].date" /> -->
                                </div>
                            </div>
                            <div class="col-2 text-right">
                                <button @click="addRow" class="btn btn-success">
                                    <font-awesome-icon icon="plus" size="sm" />
                                </button>
                                <button v-if="i !== 0" @click="removeRow(i)" class="btn btn-danger">
                                    <font-awesome-icon icon="minus" size="sm" />
                                </button>
                            </div>
                        </div>
                        <div v-if="$v.$error" class="alert alert-danger mb-0">
                            <!-- <span v-if="!$v.project.project_name.required">É richiesta almento una tratta per creare una missione.<br></span> -->
                            <span v-if="!$v.project.project_company.required">Un utente a cui assegnare la missione è richiesta.<br></span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success" @click="saveProject">
                            <font-awesome-icon :icon="['far','save']"></font-awesome-icon>&nbsp;SALVA
                        </button>
                        <button type="button" class="btn btn-light" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;ANNULLA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {
    Task
} from '@/models/Task'
import ApiService from '@/common/api.service'
import {
    required
} from 'vuelidate/lib/validators'
import {
    mapGetters
} from 'vuex'
import {
    GET_LIST,
    CREATE,
    UPDATE
    // GET_SINGLE
} from '@/store/actions.type'
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'
import {
    MODULE_NAME as PROJECTS_MODULE_NAME
} from '@/store/modules/projects.module'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
// import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
// import * as lang from 'vuejs-datepicker/src/locale'

export default {
    name: 'project-modal',
    props: {
        project: {
            type: Object
        }
    },
    data () {
        return {
            routes: [],
            projectRoutes: [{
                route: '',
                date: ''
            }]
        }
    },
    validations: {
        project: {
            // project_name: {
            //     required
            // },
            project_company: {
                required
            }
        }
    },
    computed: {
        computedUsers () {
            var _users = []
            if (this.users.data) {
                let allUsers = this.users.data
                for (var i = 0; i < allUsers.length; i++) {
                    // var type = allUsers[i].type === 1 ? 'Admin' : allUsers[i].type === 2 ? 'User' : 'Group'
                    var u = {
                        value: allUsers[i].id,
                        text: `${allUsers[i].username} - ${allUsers[i].email} ${this.currentUser.id === allUsers[i].id ? '(te stesso)' : ''}`
                    }
                    _users.push(u)
                }
            }
            return _users
        },
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            users: `${USERS_MODULE_NAME}/getList`
        }),
        newProjectName () {
            if (this.projectRoutes[0] && this.projectRoutes[0].date && this.projectRoutes[0].route.label) {
                let d = this.$date(this.projectRoutes[0].date).format('YYYYMMDD')
                return `${d}${this.projectRoutes[0].route.label.replace('-','')}`
            }
            return null
        }
    },
    methods: {
        getOptionLabel (opt) {
            return `${opt.route_from}-${opt.route_to}`
        },
        addRow () {
            this.projectRoutes.push({
                route: '',
                date: ''
            })
        },
        removeRow (index) {
            this.projectRoutes.splice(index, 1)
        },
        closeModal () {
            this.$modal.hide('project-modal')
        },
        onModalShow () {
            this.$v.$reset()
            this.fetchUsers()
            this.fetchRoutes()
        },
        fetchRoutes () {
            ApiService.query('routes').then((result) => {
                if (result.data.routes) {
                    this.routes = result.data.routes.map((r) => {
                        r.label = `${r.route_from}-${r.route_to}`
                        return r
                    })
                }
            })
        },
        fetchUsers () {
            this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {
                query: {}
            })
        },
        saveProject () {
            let tasks = []
            let pr = this.projectRoutes.filter((pr) => {
                return pr.route !== '' && pr.date !== ''
            })
            pr.forEach((pr) => {
                let task = new Task()
                task.task_name = pr.route.label
                task.task_description = pr.route.label
                task.task_sector = pr.route.sector
                task.metas = [{
                    meta_key: 'route_from',
                    value: pr.route.route_from,
                    task_type: 3
                },
                {
                    meta_key: 'route_to',
                    value: pr.route.route_to,
                    task_type: 3
                },
                {
                    meta_key: 'survey_guid',
                    value: 1,
                    task_type: 3
                },
                {
                    meta_key: 'route_date',
                    value: pr.date,
                    task_type: 3
                }
                ]
                tasks.push(task)
            })

            if (!tasks.length) {
                this.$swal('ATTENZIONE!', 'Devi inserire almeno una tratta.', 'error')
                return false
            }

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.project.tasks = tasks
                const ACTION = this.project.id ? UPDATE : CREATE
                this.project.project_name = this.newProjectName
                this.project.project_creator = this.currentUser.id
                this.$store.dispatch(`${PROJECTS_MODULE_NAME}/${ACTION}`, this.project).then((result) => {
                    if (result.status === 200) {
                        this.$swal('Ben fatto!', '', 'success')
                        this.closeModal()
                        this.$router.push({
                            name: 'mission-detail',
                            params: {
                                id: result.data.project.id
                            }
                        })
                    }
                })
            }
        }
    },
    components: {
        DatePicker
    }
}
</script>
<style lang="scss">
.v--modal {
    overflow: visible !important;
}
</style>
